module.exports = __webpack_public_path__ + "img/4_5_1.8d41c126.jpg";